module.exports = __webpack_public_path__ + "img/Google.2d1ec42d.svg";